import React from "react"
import { useImageDataURL } from "../../plugins/images"
import getSrc from "./get-src"

const Image = ({ attributes, node, data }) => {
  const {
    alt,
    borderRadius,
    href,
    margin,
    src,
    triggerId,
    width,
    height,
    optimize
  } = data

  const Tag = href ? "a" : "div"

  const key = (node && node.key) || 0

  const dataURL = useImageDataURL(key)

  const linkProps = href
    ? {
        href,
        target: "_blank",
        rel: "noopener noreferrer",
        "trigger-id": triggerId,
        onClick: e => {
          e.preventDefault()
        }
      }
    : {}

  return (
    <Tag
      style={{
        display: "block",
        ...(margin && { margin: `${margin}px 0` }),
        ...(width && { maxWidth: `${width}px` })
      }}
      {...attributes}
      {...linkProps}
    >
      <img
        src={getSrc(src, { optimize }) || dataURL}
        alt={alt}
        width={width}
        height={height}
        style={{
          maxWidth: "100%",
          height: "auto",
          borderRadius: `${borderRadius}px`,
          ...(width && { width: `${width}px` })
        }}
      />
    </Tag>
  )
}

export default Image
